<script setup lang="ts">
import { RouterLink } from 'vue-router';

import { useAppConfig } from '@composables/useAppConfig';
import { useSidebar } from '@composables/useSidebar';

const { appName } = useAppConfig();
const { isCollapsed } = useSidebar();
</script>

<template>
  <RouterLink
    to="/"
    class="flex items-center gap-3 px-4 py-4 select-none"
    :class="isCollapsed ? 'justify-center px-0' : ''"
  >
    <div class="bg-primary flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg">
      <span class="text-primary-foreground text-sm font-bold">C</span>
    </div>
    <span v-if="!isCollapsed" class="text-foreground truncate text-lg font-bold">
      {{ appName }}
    </span>
  </RouterLink>
</template>
